<template>
     
    <div class="main-list-wrap petition_details_wrap">
         <template  v-if="checkTabs">
            <div class="tab-inner-content tabs-nobg">
                <div class="tabs-content-panel tab-pad-wrap">
                    <div class="card-panels">
                        <vs-tabs>
                            <vs-tab label="Personal">
                                <SponsorPersonalInfo :visastatuses="visastatuses" :tplSection="'sponsorInfo'" :questionnaireDetails="questionnaireDetails" @download_or_view="download_or_view"  :petition="petition"></SponsorPersonalInfo>
                            </vs-tab>
                            <vs-tab label="Previous Spouse" v-if="checkProperty(petition,'sponsorInfo') && checkProperty(petition,'sponsorInfo','previousSpouse') && checkProperty(petition['sponsorInfo'],'previousSpouse','firstName')  ">
                                <previousSpouseDetails :visastatuses="visastatuses" :callFrom="'SPONSOR'" :questionnaireDetails="questionnaireDetails" :petition="petition['sponsorInfo']['previousSpouse']"></previousSpouseDetails>
                            </vs-tab>
                            <vs-tab v-if="((petition.sponsorInfo.prevEmploymentInfo && petition.sponsorInfo.prevEmploymentInfo.length > 0 && petition.sponsorInfo.prevEmploymentInfo[0].employerName!=null && petition.sponsorInfo.prevEmploymentInfo[0].employerName!='') || 
                                (petition.sponsorInfo.prevEmploymentOutsideUS && petition.sponsorInfo.prevEmploymentOutsideUS.length > 0 && petition.sponsorInfo.prevEmploymentOutsideUS[0].employerName!=null && petition.sponsorInfo.prevEmploymentOutsideUS[0].employerName!='')) || true" label="Employment">
                                <employementInfo :visastatuses="visastatuses" :tplSection="'sponsorInfo'" :questionnaireDetails="questionnaireDetails" :anyOtherPersonEmployedInUS="petition.sponsorInfo.anyOtherPersonEmployedInUS" :datatype="'SPONSOR_EMPLOYEMENT'"  :employmentList="petition.sponsorInfo.prevEmploymentInfo" :petition="petition"></employementInfo> 
                            </vs-tab>  
                            <vs-tab label="Spouse" v-if="checkProperty(petition['sponsorInfo'],'dependentsInfo') && checkProperty(petition['sponsorInfo'],'dependentsInfo','spouse') && checkProperty(petition['sponsorInfo']['dependentsInfo'],'spouse','firstName')  ">
                                <spouseInfo :visastatuses="visastatuses"  :questionnaireDetails="questionnaireDetails" :petition="petition['sponsorInfo']['dependentsInfo']['spouse']"></spouseInfo>
                            </vs-tab>
                            <vs-tab label="Children" v-if="checkProperty(petition['sponsorInfo'],'dependentsInfo') && checkProperty(petition['sponsorInfo'],'dependentsInfo','childrens') && checkProperty(petition['sponsorInfo']['dependentsInfo'],'childrens','length')>0">
                                <childrenInfo  class="pad20" :visastatuses="visastatuses"  :questionnaireDetails="questionnaireDetails" :petition="petition['sponsorInfo']['dependentsInfo']['childrens']"></childrenInfo>
                            </vs-tab>
                             <vs-tab label="Father" v-if="checkProperty(petition['sponsorInfo'],'fatherInfo') && checkProperty(petition['sponsorInfo'],'fatherInfo','firstName') ">
                                <parentsDetails :questionnaireDetails="questionnaireDetails" :category="'FATHER'" :visastatuses="visastatuses" :petition="petition['sponsorInfo']['fatherInfo']"></parentsDetails>
                            </vs-tab>
                            <vs-tab label="Mother" v-if="checkProperty(petition['sponsorInfo'],'motherInfo')  && checkProperty(petition['sponsorInfo'],'motherInfo','firstName')">
                                <parentsDetails :questionnaireDetails="questionnaireDetails" :category="'Mother'" :visastatuses="visastatuses" :petition="petition['sponsorInfo']['motherInfo']"></parentsDetails>
                            </vs-tab>
                            <vs-tab label="Affidavit" v-if="canRenderField('benfApplyAdjustStatus',questionnaireDetails, false, 'sponsorInfo.affidavitInfo' ) && checkProperty(petition['sponsorInfo'],'affidavitInfo') && checkProperty(petition['sponsorInfo'],'affidavitInfo', 'benfApplyAdjustStatus' ) ">
                                <affidatitInfo @download_or_view="download_or_view" :questionnaireDetails="questionnaireDetails" :visastatuses="visastatuses" :petition="petition['sponsorInfo']['affidavitInfo']"></affidatitInfo>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </div>
        </template>
         <template v-else>
          
            <div ><SponsorPersonalInfo :visastatuses="visastatuses" :questionnaireDetails="questionnaireDetails" @download_or_view="download_or_view" :petition="petition"></SponsorPersonalInfo></div>
        </template> 
    
    </div>
    </template>
    
    <script>
    import previousSpouseDetails  from "@/views/petition/subtabs/previousSpouseDetails.vue"; 
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import personalInfo from "@/views/petition/subtabs/personalInfo.vue";
    import SponsorPersonalInfo from "@/views/sponsorDetails/personalInfo.vue";
    import employementInfo from "@/views/petition/subtabs/employement.vue";
    import spouseInfo from "@/views/sponsorDetails/spouse.vue";
    import childrenInfo from "@/views/sponsorDetails/children.vue";
    import parentsDetails  from "@/views/petition/subtabs/parentsDetails.vue"; 
    import affidatitInfo from "@/views/sponsorDetails/affidavitInfo.vue"; 
    export default {
        data: () => ({
    
            petitionhistory: [],
    
        }),
        computed: {
            
           
            checkTabs() {
              var petition = this.petition;  
                if(this.checkProperty(petition['sponsorInfo'],'prevEmploymentInfo') && 
                    this.checkProperty(petition['sponsorInfo'],'prevEmploymentInfo','length')>0 && 
                    this.checkProperty(petition['sponsorInfo'],'prevEmploymentInfo'[0],'employerName') 
                  // &&  this.checkProperty(petition['sponsorInfo'],'prevEmploymentInfo'[0],'employerName'!="")
                ){
                    return true
                }
                if(this.checkProperty(petition['sponsorInfo'],'previousSpouse') && 
                    this.checkProperty(petition['sponsorInfo'],'previousSpouse','firstName')
                ){
                    return true
                }
                if(this.checkProperty(petition['sponsorInfo'],'dependentsInfo') &&
                 this.checkProperty(petition['sponsorInfo']['dependentsInfo'],'spouse') &&
                    this.checkProperty(petition['sponsorInfo']['dependentsInfo'],'spouse','firstName')
                ){
                    return true
                }
                if(this.checkProperty(petition['sponsorInfo'],'dependentsInfo') &&
                 this.checkProperty(petition['sponsorInfo']['dependentsInfo'],'children') &&
                    this.checkProperty(petition['sponsorInfo']['dependentsInfo'],'children','firstName')
                ){
                    return true
                }
                if(this.checkProperty(petition['sponsorInfo'],'motherInfo') && 
                    this.checkProperty(petition['sponsorInfo'],'motherInfo','firstName')
                ){
                    return true
                }
                if(this.checkProperty(petition['sponsorInfo'],'fatherInfo') && 
                    this.checkProperty(petition['sponsorInfo'],'fatherInfo','firstName')
                ){
                    return true
                }
                if(this.checkProperty(petition,'sponsorInfo') && this.checkProperty(petition['sponsorInfo'],'affidavitInfo')
                    
                ){
                    return true
                }
              return false
            }
    
        },
        props: {
            questionnaireDetails:{
                type: Array,
                default: []
            },
            petition: {
                type: Object,
                default: null
            },
            visastatuses: {
                type: Array,
                default: null
            }
        },
        components: {
            spouseInfo,
            childrenInfo,
            parentsDetails,
            SponsorPersonalInfo,  
            previousSpouseDetails,
            employementInfo,
            VuePerfectScrollbar,
            personalInfo,
            affidatitInfo
    },
        methods: {
            download_or_view(value) {
                this.$emit('download_or_view' ,value);
             },
            checPpriorPeriodOfStayInUS(data = []) {
                //enteredDate departedDate visaStatus
    
                if (data.length > 0) {
                    if (data.length == 1) {
    
                        if ((data[0].enteredDate != null && data[0].departedDate != null) || (data[0].visaStatus != '' && data[0].visaStatus != null)) {
    
                            return true;
                        } else {
                            return false;
                        }
    
                    } else {
                        return true;
    
                    }
    
                } else {
                    return false;
                }
    
            },
            gethistory() {
                if(this.checkProperty(this.petition ,'_id')){
    
                
                this.$store
                    .dispatch("petitionhistory", this.petition._id)
                    .then(response => {
                        this.petitionhistory = response.result.list;
                    });
                }
            },
            reloadPetition() {
                this.$store.dispatch("getpetition", this.petition._id).then(response => {
                    this.petition = response.data.result;
                    if (this.petition.lcaId != null) {
                        this.$store
                            .dispatch("fetchLcaDetails", this.petition.lcaId)
                            .then(response => {
                                this.lcaDetails = response.data.result;
                            });
                    }
                    let postDt = {
                        userId: '',
                        isRfeCase: false
                    }
                    if (_.has(this.petition, "rfeCase")) {
                        postDt['isRfeCase'] = this.petition['rfeCase']
                    }
                    postDt['userId'] = this.petition['userId'];
    
                    this.$store
                        .dispatch("getpetitionsdropdown", postDt)
                        .then(response => {
                            this.petitions = response;
                        });
                });
                this.$store.dispatch("petitionhistory", petitionId).then(response => {
                    this.petitionhistory = response.result.list;
                });
            },
        },
        mounted() {
            this.gethistory();
        }
    };
    </script>
    